import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { Countries } from 'src/app/model/countries';
import { BackendApiService } from 'src/app/service/backend-api.service';
import { AuthService } from '../../auth/services/auth.service';
import { SpinnerServiceService } from '../../shared/serviceSpinner/spinner-service.service';
import { Router } from '@angular/router';
import { LOCALISATIONS } from 'src/app/model/localisations';

@Component({
  selector: 'app-form-partners',
  templateUrl: './form-partners.component.html',
  styleUrls: ['./form-partners.component.css'],
})
export class FormPartnersComponent {
  soumissionForm!: FormGroup;

  showEmailErrors$ = new BehaviorSubject<boolean>(false);
  countries!: Countries[];
  showPopup: boolean = false;
  invalid: boolean = false;
  phoneCodeWhatsapp!: any[];
  phoneCode!: any[];
  controlsList: string[] = [
    'firstname',
    'lastname',
    'dateBirth',
    'gender',
    'phoneNumberOne',
    'phoneNumberTwo',
    'phoneCode',
    'emailGroup.email',
    'emailGroup.confirmEmail',
    'nationality',
    'role',
    'city',
    'organizationName',
    'expertiseSectorName',
  ];
  isError: boolean = false;
  session: boolean = false;
  noSession: boolean = false;
  applied: boolean = false;
  showSpinner: boolean = false;
  cohorteAppel: any = null;
  listrole = [
    { id: 'PARTNER_HASKE', value: 'Partenaire HASKE' },
    { id: 'COACH_HASKE', value: 'Coach HASKE' },
    { id: 'POINT_FOCAL', value: 'Point focal' },
    { id: 'MEMBRE_JURY', value: 'Membre Jury' },
  ];
  isLoading: boolean = false;
  regions!: any;
  showMessage: boolean = false;
  message: any;

  constructor(
    private formBuilder: FormBuilder,
    private service: BackendApiService,
    private authService: AuthService,
    private spinnerService: SpinnerServiceService,
    private router: Router,
  ) {
    this.soumissionForm = this.formBuilder.group({
      firstname: [null, Validators.required],
      lastname: [null, Validators.required],
      dateBirth: [null, Validators.required],
      gender: [null, Validators.required],
      phoneNumberOne: [null, Validators.required],
      phoneNumberTwo: [null],
      phoneCode: ['221', Validators.required],
      // isWhatsApp: [null, Validators.required],
      // whatsAppNumber: [null],
      phoneCodeForWhatsApp: ['221'],
      emailGroup: this.formBuilder.group({
        email: [null, [Validators.required, Validators.email]],
        confirmEmail: [null, [Validators.required, Validators.email]],
      }),
      nationality: [null, Validators.required],
      roles: [null, Validators.required],
      organizationName: [null, Validators.required],
      conditions: [null, Validators.requiredTrue],
      expertiseSectorName: [null, Validators.required],
      city: [null, Validators.required],
    });
  }

  ngOnInit(): void {
    this.regions = LOCALISATIONS.Regions;
    this.spinnerService.hideSpinner();
    this.authService.getCountries().subscribe((data) => {
      this.countries = data.sort((c, d) => (c.name < d.name ? -1 : 1));
      // console.log('country :', this.countries);
    });
    this.authService.getCountries().subscribe((data) => {
      //console.log(data);
      this.phoneCode = data.sort((c, d) => c.phoneCode - d.phoneCode);
      //console.log(this.phoneCode);
      this.phoneCodeWhatsapp = this.phoneCode;
    });

    this.soumissionForm.get('nationality')?.valueChanges.subscribe((values) => {
      if (values === 'Autre') {
        this.soumissionForm.addControl(
          'otherCountry',
          this.formBuilder.control(null, Validators.required),
        );
        this.controlsList.push('otherCountry');
      } else {
        this.soumissionForm.removeControl('otherCountry');
        this.controlsList = this.controlsList.filter(
          (e) => e !== 'otherCountry',
        );
      }
    });
  }

  onSubmitForm() {
    this.isLoading = true;
    this.spinnerService.showSpinner();

    if (this.soumissionForm.invalid) {
      this.showPopup = true;
      this.soumissionForm.markAllAsTouched();
      return;
    }
    const formValue = this.soumissionForm.value;
    formValue.email = formValue['emailGroup']?.email;
    // console.log(formValue);
    this.applyPartner(formValue);
  }

  applyPartner(candidatureRequest: any) {
    this.spinnerService.showSpinner();
    this.service.applyPartner(candidatureRequest).subscribe({
      next: (response) => {
        this.spinnerService.hideSpinner();
        this.isLoading = false;
        if (response && response.error) {
          this.message = response.message;
          this.togglePopup();
          return;
        }
        sessionStorage.setItem('canSuccess', '1');
        setTimeout(() => {
          this.soumissionForm.reset();
          this.isError = false;
          this.router.navigateByUrl(`candidature/enrollement/reussie`);
        }, 100);
      },
      error: (error) => {
        // console.log(error);
        this.isLoading = false;
        this.spinnerService.hideSpinner();
        this.isError = true;
      },
    });
  }

  Age(dateOfBirth: string): number {
    const today = new Date();
    const birthDate = new Date(dateOfBirth);

    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();
    if (
      monthDifference < 0 ||
      (monthDifference === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }
    return age;
  }

  isFieldInvalid(controlName: string): boolean | null {
    const control = this.soumissionForm.get(controlName);
    return control && control.invalid && control.touched;
  }

  isFieldInvalidForMails(controlName: string): boolean | null {
    const control = this.soumissionForm.get(controlName);
    return control && control.errors?.['required'] && control.touched;
  }

  isMailFieldInvalid(control: string): boolean | null {
    return (
      this.soumissionForm.get(control)?.errors?.['email'] &&
      this.soumissionForm.get(control)?.touched
    );
  }
  togglePopup() {
    this.showMessage = !this.showMessage;
  }
}
